<mat-toolbar *ngIf="formNavigator.activeRouteSegment() === RouteSegments.LIST_ROUTE">
  <ng-container *transloco="let t;">
    <div class="dense-3 toolbar-inputs" [ngStyle]="{'padding-top': '12px' }">
      <base-entity-query [entityDescriptor]="entityDescriptor()"></base-entity-query>
      <div class="filter-wrapper">
        <label class="field-label" [attr.for]="entityDescriptor().createTestId('filter-input')">{{ t('base_entity.toolbar.filter_label') }}</label>
        <mat-form-field subscriptSizing="dynamic">
          <input #filterInput [id]="entityDescriptor().createTestId('filter-input')" [attr.data-testid]="entityDescriptor().createTestId('filter')" matInput type="text" (keyup)="onDoFilter( $event )">
          @if (filterInput.value) {
            <button [attr.data-testid]="entityDescriptor().createTestId('filter-clear')" type="button" mat-icon-button matSuffix aria-label="Clear filter" (click)="onClearFilter(filterInput)">
              <mat-icon>cancel</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
    </div>
  </ng-container>
  <span class="toolbar-spacer"></span>
  @if(isSmallDevice()) {
    <div [ngClass]="layoutService.layoutClass()">
      <button test-id="menu-button" mat-button [matMenuTriggerFor]="beforeMenu"><mat-icon>menu</mat-icon> Choose action</button>
      <mat-menu #beforeMenu="matMenu" xPosition="before">
        <button [attr.data-testid]="entityDescriptor().createTestId('edit')" mat-menu-item [disabled]="!isEditEnabled()" (click)="onEditEntity()"><mat-icon>edit</mat-icon> Edit</button>
        <button [attr.data-testid]="entityDescriptor().createTestId('new')" mat-menu-item [disabled]="!isNewEnabled()" (click)="onAddEntity()"><mat-icon>add</mat-icon> New</button>
        <button [attr.data-testid]="entityDescriptor().createTestId('delete')" mat-menu-item [disabled]="!isDeleteEnabled()" (click)="onDeleteEntities()"><mat-icon>delete</mat-icon> Delete</button>
      </mat-menu>
    </div>
  } @else {
    <div [ngClass]="layoutService.layoutClass()">
      <button [attr.data-testid]="entityDescriptor().createTestId('edit')" mat-button [disabled]="!isEditEnabled()" (click)="onEditEntity()"><mat-icon>edit</mat-icon> Edit</button>
      <button [attr.data-testid]="entityDescriptor().createTestId('new')" mat-button [disabled]="!isNewEnabled()" (click)="onAddEntity()"><mat-icon>add</mat-icon> New</button>
      <button [attr.data-testid]="entityDescriptor().createTestId('delete')" mat-button [disabled]="!isDeleteEnabled()" (click)="onDeleteEntities()"><mat-icon>delete</mat-icon> Delete</button>
    </div>
  }
</mat-toolbar>
